import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import SignUp from "../components/SignUp";
import LandingPage from "../components/LandingPage";
import ContactUs from "../components/ContactUs";
import PDFViewer from "../components/PDFViewer";

const Nav = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/contact" element={<ContactUs />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="/pdf/:documentType" element={<PDFViewer />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default Nav;
